import React from 'react';

import {Container, HelpArticleText, HelpArticleIcon} from './styles';

interface IHelpArticleItem {
  text: string;
  action: () => void;
  showBorder?: boolean;
}

export function HelpArticleItem({
  text,
  action,
  showBorder = true,
}: IHelpArticleItem) {
  return (
    <Container
      onPress={action}
      activeOpacity={1}
      style={{
        borderTopWidth: showBorder ? 1 : 0,
      }}>
      <HelpArticleText>{text}</HelpArticleText>
      <HelpArticleIcon name="chevron-right" />
    </Container>
  );
}
